/**
 * Registro de contenido del tracker por idioma.
 *
 * El `Record<TrackerLocale, TrackerCopy>` es el guardián de paridad: si a un
 * idioma le falta una clave, no compila.
 */

import type { TrackerLocale } from '../types'
import type { TrackerCopy } from './types'
import { TRACKER_COPY_ES } from './es'
import { TRACKER_COPY_EN } from './en'
import { TRACKER_COPY_PT } from './pt'
import { TRACKER_COPY_IT } from './it'
import { TRACKER_COPY_FR } from './fr'
import { TRACKER_COPY_JA } from './ja'
import { TRACKER_COPY_DE } from './de'

export type { TrackerCopy, FaqItem, PhaseMap } from './types'

export const TRACKER_COPY: Record<TrackerLocale, TrackerCopy> = {
  es: TRACKER_COPY_ES,
  en: TRACKER_COPY_EN,
  pt: TRACKER_COPY_PT,
  it: TRACKER_COPY_IT,
  fr: TRACKER_COPY_FR,
  ja: TRACKER_COPY_JA,
  de: TRACKER_COPY_DE,
}

import { TRACKER_LOCALES } from '../types'

export { TRACKER_LOCALES }

/** True si el segmento de locale es uno de los mercados publicados. */
export function isTrackerLocale(locale: string): locale is TrackerLocale {
  return TRACKER_LOCALES.some((publishedLocale) => publishedLocale === locale)
}

/** Copy del locale pedido; un locale desconocido cae a español. */
export function getTrackerCopy(locale: string): TrackerCopy {
  return isTrackerLocale(locale) ? TRACKER_COPY[locale] : TRACKER_COPY.es
}

/** Etiqueta BCP-47 / Open Graph del locale. Fuente única: lib/locale-prefix. */
export { OG_LOCALE } from '@/lib/locale-prefix'

/**
 * Sustituye los marcadores `{clave}` de una plantilla. Deliberadamente mínimo:
 * no hay pluralización ni formatos, porque el copy ya está escrito para no
 * necesitarlos (los números van en su propia celda, no dentro de la frase).
 */
export function formatTemplate(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) =>
    key in values ? String(values[key]) : match
  )
}
